// Generated by generate-host-overrides — DO NOT EDIT
/* eslint-disable */

export const HOST_OVERRIDES: Record<string, string> = {
  'accountgroup.v1.AccountGroupService': 'account-group-api-${ENV}.vendasta-internal.com',
  'accountgroupmedia.v1.MediaService': 'account-group-media-api-${ENV}.apigateway.co',
  'advertising.v1.Admin': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Adwords': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.AdwordsCredentials': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.AdwordsSettingsService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Authentication': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Business': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.CallRail': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.CampaignEvents': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.CampaignSettingsService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.CampaignSuggestions': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Campaigns': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Credentials': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.ExecutiveReport': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Facebook': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.FacebookCredentials': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.FacebookSettingsService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.HistoricalData': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Linkedin': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.LinkedinCredentials': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.LocalAds': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.LocalAdsSettingsService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Marchex': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.MarkupService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Matchcraft': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Microsoft': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.MicrosoftCredentials': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.PartnerConfigService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.SettingsService': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Stats': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.TaboolaCredentials': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Telmetrics': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.TikTok': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Whatsapp': 'digital-advertising-api-${ENV}.apigateway.co',
  'advertising.v1.Xandr': 'digital-advertising-api-${ENV}.apigateway.co',
  'astbe.v1.Asterisk': 'astbe-api-${ENV}.apigateway.co',
  'atlas.v1.Atlas': 'atlas-api-${ENV}.apigateway.co',
  'atlas.v1.Languages': 'atlas-api-${ENV}.apigateway.co',
  'atlas.v1.Pins': 'atlas-api-${ENV}.apigateway.co',
  'composer.v1.Composer': 'composer-api-${ENV}.apigateway.co',
  'contacts.v1.ContactEmailService': 'contacts-api-${ENV}.vendasta-internal.com',
  'contacts.v1.Contacts': 'contacts-api-${ENV}.vendasta-internal.com',
  'contacts.v1.UserList': 'contacts-api-${ENV}.vendasta-internal.com',
  'conversation.v1.ConversationAIService': 'conversation-${ENV}.apigateway.co',
  'conversation.v1.ConversationService': 'conversation-${ENV}.apigateway.co',
  'conversation.v1.web_chat_widget.WebChatWidget': 'conversation-${ENV}.apigateway.co',
  'crm.v1.CRMAssociationService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMCompanyService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMCustomObjectService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMCustomObjectTypeService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMFieldSchemaCustomizationService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMFieldSchemaService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMOpportunityService': 'crm-${ENV}.apigateway.co',
  'crm.v1.CRMService': 'crm-${ENV}.apigateway.co',
  'crm.v1.Pipelines': 'crm-${ENV}.apigateway.co',
  'email.v1.Admin': 'email-api-${ENV}.apigateway.co',
  'email.v1.Blocks': 'email-api-${ENV}.apigateway.co',
  'email.v1.DisposableEmail': 'email-api-${ENV}.apigateway.co',
  'email.v1.Domain': 'email-api-${ENV}.apigateway.co',
  'email.v1.EmailClient': 'email-api-${ENV}.apigateway.co',
  'email.v1.EmailEventService': 'email-api-${ENV}.apigateway.co',
  'email.v1.EmailService': 'email-api-${ENV}.apigateway.co',
  'email.v1.InboundEmailConfigs': 'email-api-${ENV}.apigateway.co',
  'email.v1.InboundMessageMappingService': 'email-api-${ENV}.apigateway.co',
  'email.v1.InboundMessageService': 'email-api-${ENV}.apigateway.co',
  'email.v1.Message': 'email-api-${ENV}.apigateway.co',
  'email.v1.PartnerEmailQuotaService': 'email-api-${ENV}.apigateway.co',
  'email.v1.Preferences': 'email-api-${ENV}.apigateway.co',
  'email.v1.RecipientStatus': 'email-api-${ENV}.apigateway.co',
  'email.v1.Send': 'email-api-${ENV}.apigateway.co',
  'email.v1.SendGridService': 'email-api-${ENV}.apigateway.co',
  'email.v1.Senders': 'email-api-${ENV}.apigateway.co',
  'email.v1.SubUser': 'email-api-${ENV}.apigateway.co',
  'email.v1.TrackedMessages': 'email-api-${ENV}.apigateway.co',
  'email.v1.Validation': 'email-api-${ENV}.apigateway.co',
  'eventbroker.v1.EventBroker': 'event-broker-api-${ENV}.apigateway.co',
  'facebook.v1.Facebook': 'facebook-api-${ENV}.apigateway.co',
  'forms.v1.Forms': 'forms-${ENV}.apigateway.co',
  'googleanalytics.v1.Records': 'google-analytics-api-${ENV}.apigateway.co',
  'googleanalytics.v1.Views': 'google-analytics-api-${ENV}.apigateway.co',
  'googleanalytics.v2.GA4Properties': 'google-analytics-api-${ENV}.apigateway.co',
  'googleanalytics.v2.GA4Records': 'google-analytics-api-${ENV}.apigateway.co',
  'googleanalytics.v2.Records': 'google-analytics-api-${ENV}.apigateway.co',
  'googleanalytics.v2.Stats': 'google-analytics-api-${ENV}.apigateway.co',
  'googleanalytics.v2.Views': 'google-analytics-api-${ENV}.apigateway.co',
  'group.v1.GroupService': 'group-api-${ENV}.apigateway.co',
  'gsuite.v1.CustomerService': 'g-suite-api-${ENV}.apigateway.co',
  'gsuite.v1.DomainService': 'g-suite-api-${ENV}.apigateway.co',
  'gsuite.v1.GoogleWorkspaceSuperadmin': 'g-suite-api-${ENV}.apigateway.co',
  'gsuite.v1.PartnerService': 'g-suite-api-${ENV}.apigateway.co',
  'gsuite.v1.SubscriptionService': 'g-suite-api-${ENV}.apigateway.co',
  'gsuite.v1.UserService': 'g-suite-api-${ENV}.apigateway.co',
  'heimdall.v1.Heimdall': 'heimdall-api-${ENV}.apigateway.co',
  'heimdall.v2.Heimdall': 'heimdall-api-${ENV}.apigateway.co',
  'iam.v1.IAM': 'iam-api-${ENV}.apigateway.co',
  'iam.v1.UserIAM': 'iam-api-${ENV}.apigateway.co',
  'iam.v2.IAM': 'iam-api-${ENV}.apigateway.co',
  'iam.v2.IAMAdmin': 'iam-api-${ENV}.apigateway.co',
  'iam.v2.IAMInternal': 'iam-api-${ENV}.apigateway.co',
  'iam.v2.IAMSSO': 'iam-api-${ENV}.apigateway.co',
  'libpostal.v1.LibPostal': 'libpostal-api-${ENV}.apigateway.co',
  'listing_products.v1.BrandVisibilityService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.Citations': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.ListingProductsService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.ListingProfileService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.ListingSourceService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.PartnerSettingsService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.SEOAuditService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.SEOService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.SEOSuggestedKeywordsService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_products.v1.SuggestionService': 'listing-products-api-${ENV}.apigateway.co',
  'listing_sync_pro.v1.ListingSyncProService': 'listing-sync-pro-api-${ENV}.apigateway.co',
  'marketplaceapps.v1.Editions': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v1.MarketplaceApps': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v1.Vendor': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.AppPricing': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.AppReportingCodeOverrides': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.BasicInventoryItems': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.Category': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.FulfillmentOrderConfigService': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.Items': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.MarketplaceAppData': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.Partner': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.ProductAuxiliaryFieldData': 'marketplace-apps-api-${ENV}.apigateway.co',
  'marketplaceapps.v2.ProductAuxiliaryFieldSchema': 'marketplace-apps-api-${ENV}.apigateway.co',
  'media.v1.ImageService': 'media-api-${ENV}.apigateway.co',
  'media.v2.MediaService': 'media-api-${ENV}.apigateway.co',
  'media.v3.Files': 'media-api-${ENV}.apigateway.co',
  'meetings.v1.MeetingExternal': 'meetings-${ENV}.apigateway.co',
  'missioncontrol.v1.MissionControl': 'mission-control-api-${ENV}.apigateway.co',
  'missioncontrol.v1.MissionControlAdmin': 'mission-control-api-${ENV}.apigateway.co',
  'missioncontrol.v2.AppMetrics': 'mission-control-api-${ENV}.apigateway.co',
  'missioncontrol.v2.MissionControl': 'mission-control-api-${ENV}.apigateway.co',
  'missioncontrol.v2.ServiceLevels': 'mission-control-api-${ENV}.apigateway.co',
  'missioncontrol.v2.User': 'mission-control-api-${ENV}.apigateway.co',
  'multilocation.v1.MultiLocation': 'multi-location-api-${ENV}.apigateway.co',
  'multilocationanalytics.v1.AnalyticsService': 'multi-location-analytics-api-${ENV}.apigateway.co',
  'notifications.v1.Notifications': 'notifications-api-${ENV}.apigateway.co',
  'notifications.v1.NotificationsAdmin': 'notifications-api-${ENV}.apigateway.co',
  'notifications.v1.NotificationsProvider': 'notifications-api-${ENV}.apigateway.co',
  'notifications.v1.Unsubscribe': 'notifications-api-${ENV}.apigateway.co',
  'notifications.v1.legacy.LegacyNotificationPreference': 'notifications-api-${ENV}.apigateway.co',
  'orderfulfillment.v1.FulfillmentFormSubmissionService': 'order-fulfillment-api-${ENV}.apigateway.co',
  'orderfulfillment.v1.FulfillmentOrderService': 'order-fulfillment-api-${ENV}.apigateway.co',
  'orderfulfillment.v1.OrderFulfillmentService': 'order-fulfillment-api-${ENV}.apigateway.co',
  'partner.v1.AcquisitionDataService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.Addon': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.BrandingV2Service': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.BusinessCenter': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.CannyService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.CustomerSurveyService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.FeatureFlags': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.FreeTrialService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.GrowthEventService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.IAM': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.Partner': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerHealths': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerLegacy': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerModelService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerSignup': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerTermsOfService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerTrial': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PartnerUserAgreementTermsOfService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.PreviewEmailService': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.Rewards': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.Sales': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.Stats': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.SubscriptionTiers': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.TaskManager': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.UserOnboarding': 'partner-api-${ENV}.apigateway.co',
  'partner.v1.Whitelabel': 'partner-api-${ENV}.apigateway.co',
  'reputation.v1.ListingService': 'reputation-api-${ENV}.apigateway.co',
  'reputation.v1.NetPromoterScoreService': 'reputation-api-${ENV}.apigateway.co',
  'reputation.v1.ReviewService': 'reputation-api-${ENV}.apigateway.co',
  'sales.v1.BusinessActivity': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.BusinessService': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.CampaignService': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.Contacts': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.ExternalIdentifiers': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.Freshdesk': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.LegacyEvents': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.Meeting': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.PartnerService': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.Sales': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.SalesActivityService': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.SalesTeamService': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.Tasks': 'sales-api-${ENV}.apigateway.co',
  'sales.v1.UserActionsProvider': 'sales-api-${ENV}.apigateway.co',
  'sales.v2beta1.ActionLists': 'sales-api-${ENV}.apigateway.co',
  'sales.v2beta1.BusinessService': 'sales-api-${ENV}.apigateway.co',
  'sales.v2beta1.CampaignService': 'sales-api-${ENV}.apigateway.co',
  'sales.v2beta1.CancellationRequests': 'sales-api-${ENV}.apigateway.co',
  'sales.v2beta1.Contacts': 'sales-api-${ENV}.apigateway.co',
  'sales.v2beta1.Salespeople': 'sales-api-${ENV}.apigateway.co',
  'salesorders.v1.SalesOrders': 'sales-orders-${ENV}.apigateway.co',
  'salesorders.v1.SalesOrdersAuxiliaryFieldSchema': 'sales-orders-${ENV}.apigateway.co',
  'snapshot.v1.AIOptimizationSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.AISearchVisibilityAuditService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.AdvertisingSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.ArtificialIntelligence': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.CurrentSnapshot': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.EcommerceSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.ListingSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.ReviewSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.SEOSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.SnapshotLiteService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.SnapshotRecord': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.SnapshotService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.SocialSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.TechnologySectionService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.TechnologyService': 'snapshot-api-${ENV}.apigateway.co',
  'snapshot.v1.WebsiteSectionService': 'snapshot-api-${ENV}.apigateway.co',
  'socialdrafts.v1.Drafts': 'social-drafts-api-${ENV}.apigateway.co',
  'socialposts.v1.SocialPosts': 'social-posts-${ENV}.apigateway.co',
  'socialposts.v2.SocialPostsV2': 'social-posts-${ENV}.apigateway.co',
  'socialposts.v2.WordpressPluginService': 'social-posts-${ENV}.apigateway.co',
  'srereporting.v1.Availability': 'sre-reporting-api-${ENV}.apigateway.co',
  'srereporting.v1.SLOHistory': 'sre-reporting-api-${ENV}.apigateway.co',
  'srereporting.v1.ServiceLevel': 'sre-reporting-api-${ENV}.apigateway.co',
  'srereporting.v1.User': 'sre-reporting-api-${ENV}.apigateway.co',
  'sso.v1.Consent': 'sso-api-${ENV}.apigateway.co',
  'sso.v1.ConsentAdmin': 'sso-api-${ENV}.apigateway.co',
  'sso.v1.IdentityProvider': 'sso-api-${ENV}.apigateway.co',
  'sso.v1.IdentityProviderAdmin': 'sso-api-${ENV}.apigateway.co',
  'sso.v1.ServiceProvider': 'sso-api-${ENV}.apigateway.co',
  'sso.v1.ServiceProviderAdmin': 'sso-api-${ENV}.apigateway.co',
  'task.v1.TaskCommand': 'task-api-${ENV}.apigateway.co',
  'task.v1.TaskQuery': 'task-api-${ENV}.apigateway.co',
  'taskmanager.v1.AccountProductDetails': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.Accounts': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.BusinessFulfillmentSettings': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.CustomTags': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.DigitalAgents': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.Group': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.Metrics': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.OrderForm': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.ProductFulfillment': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.ProductFulfillmentSettings': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.RecurringTasks': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.SocialCalendar': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.TaskAuxiliaryFieldData': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.TaskAuxiliaryFieldSchema': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.TaskManager': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.TaskManagerAuth': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.TaskStatuses': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.Templates': 'task-manager-api-${ENV}.apigateway.co',
  'taskmanager.v1.Vendor': 'task-manager-api-${ENV}.apigateway.co',
  'templates.v1.TemplatesService': 'templates-api-${ENV}.apigateway.co',
  'tesseract.v1.Admin': 'tesseract-api-${ENV}.apigateway.co',
  'tesseract.v1.Tesseract': 'tesseract-api-${ENV}.apigateway.co',
  'twitter.v1.Twitter': 'twitter-api-${ENV}.apigateway.co',
  'url_shortener.v1.UrlShortener': 'url-shortener-api-${ENV}.apigateway.co',
  'vanalytics.v1.VAnalytics': 'vanalytics-${ENV}.apigateway.co',
  'web_crawler.v1.CollectorService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.IncidentService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.ListingService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.LockdownService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.PlatformHealth': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.RescrapeService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.ScraperService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.SearchService': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.SiteCrawl': 'web-crawler-api-${ENV}.apigateway.co',
  'web_crawler.v1.TavilyNamespaceLimitService': 'web-crawler-api-${ENV}.apigateway.co',
  'wordpress_hosting.v1.PartnerApi': 'websitepro-${ENV}.apigateway.co',
  'wsp_admin_center.v1.SearchService': 'websitepro-${ENV}.apigateway.co',
  'wsp_admin_center.v1.WordpressService': 'websitepro-${ENV}.apigateway.co',
  'wsp_monitor.v1.Monitor': 'websitepro-${ENV}.apigateway.co',
  'wsp_site_info.v1.Cache': 'websitepro-${ENV}.apigateway.co',
  'wsp_site_info.v1.SiteInfo': 'websitepro-${ENV}.apigateway.co',
  'wsp_support_tools.v1.SiteManager': 'websitepro-${ENV}.apigateway.co',
  'wsp_wp_manager.v1.PageSpeedService': 'websitepro-${ENV}.apigateway.co',
  'wsp_wp_manager.v1.SiteOptionsService': 'websitepro-${ENV}.apigateway.co',
  'yext.v1.EntityAdmin': 'yext-api-${ENV}.apigateway.co',
  'yext.v1.Yext': 'yext-api-${ENV}.apigateway.co',
};

export const HOST_PREFIX_OVERRIDES: Record<string, string> = {
  'accountgroup': 'account-group',
  'accountgroupmedia': 'account-group-media',
  'adwords': 'adwords-service',
  'apiyext': 'api-yext',
  'auxiliarydata': 'auxiliary-data',
  'businesscategories': 'business-categories',
  'cloudblue': 'cloud-blue',
  'conciergeaccounts': 'concierge-accounts',
  'constantcontact': 'constant-contact',
  'customervoice': 'customer-voice-service',
  'datatransfer': 'data-transfer',
  'developercenter': 'developer-center',
  'developertraining': 'developer-training',
  'emailbuilder': 'email-builder',
  'eventbroker': 'event-broker',
  'executivereport': 'executive-report',
  'ext-maps-booking-feeds': 'reserve-with-google-feeds',
  'ext-maps-booking-partner': 'reserve-with-google-api',
  'factualdatatransfer': 'factual-data-transfer',
  'gmb': 'google-my-business',
  'googleanalytics': 'google-analytics',
  'googlesearchconsole': 'google-search-console',
  'helpcenter': 'help-center',
  'iamresources': 'iam-resources',
  'listingscore': 'listing-score',
  'listingsearch': 'listing-search',
  'localmarketingindex': 'local-marketing-index',
  'login': 'vendasta-login-center',
  'marketplaceanalytics': 'marketplace-analytics',
  'marketplaceapps': 'marketplace-apps',
  'missioncontrol': 'mission-control',
  'msoffice': 'ms-office',
  'multilocation': 'multi-location',
  'multilocationanalytics': 'multi-location-analytics',
  'orderfulfillment': 'order-fulfillment',
  'partnertrudsubscribers': 'partner-trud-subscribers',
  'platformusers': 'platform-users',
  'salesopportunities': 'sales-opportunities',
  'salesorders': 'sales-orders',
  'shoppablefeed': 'shoppable-feed',
  'snapshotwidget': 'snapshot-widget',
  'socialdrafts': 'social-drafts',
  'socialposts': 'social-posts',
  'srereporting': 'sre-reporting',
  'taskmanager': 'task-manager',
  'theloop': 'the-loop',
  'vendasta-citations': 'citations',
  'vendastatypes': 'vendasta-types',
  'vendorwebhooks': 'vendor-webhooks',
};
